import Vue from 'vue'
import App from './App.vue'
import 'lib-flexible/flexible.js'
import './assets/style/reset.css'
import router from '../src/Router/index'
import {
  Button,
  List,
  Field,
  Uploader,
  Toast,
  DatetimePicker,
  Cell,
  Area,
  ActionSheet ,
  Form,
  Popup,
  Collapse,
  CollapseItem,
  Search,
} from 'vant';
import store from '../src/vuex/store'
// 复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.use(Button);
Vue.use(List);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Cell);
Vue.use(Area);
Vue.use(ActionSheet);
Vue.use(Form);
Vue.use(Popup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Search);
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})
new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')